<script>
import moment from "moment";

export default {
  name: "popupDateTimePicker",
  components: {},
  props: {
    //显示隐藏
    visible: {
      type: Boolean,
      default: false
    },
    //值
    value: {
      type: [String, Number],
      default: ""
    },
    //最小时间
    minDate: {
      type: String,
      default: ""
    },
    //最大时间
    maxDate: {
      type: String,
      default: ""
    },
    //格式化
    format: {
      type: String,
      default: ""
    },
    //类型
    type: {
      type: String,
      default: "date"
    },
    //确认描述
    confirmButtonText: {
      type: String,
      default: "确认"
    },
    //取消描述
    cancelButtonText: {
      type: String,
      default: "取消"
    },
    //过滤方法
    filter: {
      type: Function
    },
    //挂载dom
    getContainer: {
      type: String,
      default: "#app"
    }
  },
  data() {
    return {
      baseFormat: {
        datetime: "YYYY-MM-DD HH:mm",
        date: "YYYY-MM-DD",
        time: "HH:mm",
        "year-month": "YYYY-MM"
      }
    };
  },
  model: {
    prop: "visible"
  },
  watch: {},
  computed: {
    /**
     * @description: 最小时间
     * @param {*}
     * @return {*}
     */
    min() {
      let { minDate } = this;
      if (this.type == "time") {
        return null;
      } else if (minDate) {
        if (!(minDate instanceof moment)) {
          minDate = moment(minDate);
        }
        return minDate.toDate();
      } else {
        return moment()
          .add(-10, "y")
          .toDate();
      }
    },
    /**
     * @description: 最大时间
     * @param {*}
     * @return {*}
     */
    max() {
      let { maxDate } = this;
      if (this.type == "time") {
        return null;
      } else if (maxDate) {
        if (!(maxDate instanceof moment)) {
          maxDate = moment(maxDate);
        }
        return maxDate.toDate();
      } else {
        return moment()
          .add(10, "y")
          .toDate();
      }
    },
    /**
     * @description: 最终格式化方式
     * @param {*}
     * @return {*}
     */
    realFormat() {
      let { format, baseFormat, type } = this;
      return format ? format : baseFormat[type];
    }
  },
  created() {},
  methods: {
    /**
     * @description: 格式化
     * @param {*} type
     * @param {*} val
     * @return {*}
     */
    formatter(type, val) {
      switch (type) {
        case "year":
          return `${val}年`;
        case "month":
          return `${val}月`;
        case "day":
          return `${val}日`;
        case "hour":
          return `${val}时`;
        case "minute":
          return `${val}分`;
        default:
          return val;
      }
    },
    /**
     * @description: 确认
     * @param {*} val
     * @return {*}
     */
    confirm(e) {
      let { realFormat, type } = this;
      if (type != "time") e = moment(e).format(realFormat);
      this.$emit("input", false);
      this.$emit("update:value", e);
      this.$emit("confirm", e);
    },
    /**
     * @description: 取消
     * @param {*}
     * @return {*}
     */
    cancel(e) {
      this.$emit("input", false);
      this.$emit("cancel", e);
    },
    /**
     * @description: 弹窗 渲染
     * @param {*}
     * @return {*}
     */
    popupRender() {
      const { visible, getContainer } = this;
      const option = {
        props: {
          position: "bottom",
          value: visible,
          getContainer
        },
        on: {
          input: val => {
            this.$emit("input", val);
          }
        }
      };
      return <van-popup {...option}>{this.pickerRender()}</van-popup>;
    },
    /**
     * @description: 时间渲染器 渲染
     * @param {*}
     * @return {*}
     */
    pickerRender() {
      let { value, type } = this;
      if (type == "time") {
        value = value ? value : moment().format(this.realFormat);
      } else {
        value = value ? moment(value).toDate() : new Date();
      }
      const option = {
        props: {
          value,
          type,
          minDate: this.min,
          // maxDate: this.max,
          formatter: this.formatter,
          cancelButtonText: this.cancelButtonText,
          confirmButtonText: this.confirmButtonText,
          filter: this.filter
        },
        ref: "datePicker",
        on: {
          cancel: this.cancel,
          confirm: this.confirm
        }
      };
      return <van-datetime-picker {...option} />;
    }
  },
  render() {
    return this.popupRender();
  }
};
</script>

<style lang="less" scoped>
.form-date {
  border-bottom: 1px solid #ebedf0;
}

// /deep/.van-picker__cancel,
// .van-picker__confirm {
//   height: 100%;
//   padding: 0 16px;
//   font-size: 14px;
//   background-color: transparent;
//   border: none;
//   cursor: pointer;
// }
</style>
